var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLockerSettings(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2 11.2V10.4C11.2 9.9584 11.5584 9.6 12 9.6H14.4V13.6C14.4 14.0416 14.0416 14.4 13.6 14.4H2.4C1.9584 14.4 1.6 14.0416 1.6 13.6V9.6H4C4.4416 9.6 4.8 9.9584 4.8 10.4V11.2C4.8 12.084 5.516 12.8 6.4 12.8H9.6C10.484 12.8 11.2 12.084 11.2 11.2ZM9.6 9.6V11.2H6.4V9.6C6.4 8.716 5.684 8 4.8 8H1.6L2.88 1.6H13.12L14.4 8H11.2C10.316 8 9.6 8.716 9.6 9.6ZM16 8L14.5288 0.6432C14.4536 0.2688 14.1256 0 13.744 0H2.256C1.8744 0 1.5464 0.2688 1.4712 0.6432L0 8V14.4C0 15.284 0.716 16 1.6 16H14.4C15.284 16 16 15.284 16 14.4V8Z",
    fill: "#3B414D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockerSettings);
export default __webpack_public_path__ + "static/media/locker-settings.24724497573b5c11de656b2679729ff2.svg";
export { ForwardRef as ReactComponent };